import React from 'react';
import { useHistory } from 'react-router-dom';
import { Button } from '@material-ui/core';
import Usuarios from './Usuarios';

const UsuariosIndex = () => {
    const history = useHistory();

    return (
        <div className="w-full p-4 md:p-6">
            <div className="flex justify-between items-center mb-6">
                <div>
                    <h1 className="text-2xl font-bold text-gray-900 tracking-tight">Usuarios</h1>
                    <p className="text-sm text-gray-500 mt-1">Catálogo de usuarios del sistema y permisos de acceso</p>
                </div>
                <Button
                    className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-6 rounded-full shadow-md"
                    variant="contained"
                    color="primary"
                    onClick={() => history.push(`/Catalogo/Usuario`)}
                >
                    + Nuevo Usuario
                </Button>
            </div>

            <Usuarios />
        </div>
    );
};

export default UsuariosIndex;
